export function setupCalendarAccordion() {
    const calendarItems = document.querySelectorAll('.calendar__item');
    const locationHash = window.location.hash.toString();

    if (locationHash.length > 0) {
        const element = document.querySelector(locationHash);

        if (element) {
            const elementReadMoreText = element.querySelector('.richtext--readmore');

            if (elementReadMoreText) {
                elementReadMoreText.style.height = `${elementReadMoreText.scrollHeight}px`;
                elementReadMoreText.classList.add('js-open');
            }
        }
    }

    function clickReadMoreBtn(e) {
        const link = e.currentTarget;
        const calendarItem = link.closest('.calendar__item');

        if (calendarItem) {
            const readMoreText = calendarItem.querySelector('.richtext--readmore');

            if (readMoreText) {
                if (readMoreText.classList.contains('js-open')) {
                    readMoreText.style.height = null;
                    readMoreText.classList.remove('js-open');
                } else {
                    readMoreText.style.height = `${readMoreText.scrollHeight}px`;
                    readMoreText.classList.add('js-open');
                }
            }
        }
    }

    Array.from(calendarItems).forEach(item => {
        const readMoreBtn = item.querySelector('.btn + a');
        readMoreBtn.addEventListener('click',clickReadMoreBtn);
    });
}